export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9002/api/v1';

export const REACT_APP_SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL || 'http://localhost:9002';
